export enum TipoIdentificacao {
  anonimo = 'Anônimo',
  identificado = 'Identificado',
}
